{
  "el": {
    "decision_type": {
      "actions": {
        "add_competitor": "Προσθήκη ανταγωνιστή",
        "add_decision_partners": "Συνεργάτες απόφασης",
        "auto_share_proposals": "Αυτόματη κοινοποίηση εγκεκριμένων προτάσεων",
        "change_rights": "Αλλαγή δικαιωμάτων",
        "collapse": "Σύμπτυξη",
        "create_category": "Προσθήκη νέας κατηγορίας",
        "delete": "Διαγραφή",
        "deleteMultiple": "Διαγραφή...",
        "delete_cancel": "Ακύρωση",
        "delete_group": "Διαγραφή ομάδας συνεργατών",
        "download": "Λήψη",
        "edit": "Επεξεργασία",
        "edit_decision_partners": "Επεξεργασία συνεργατών απόφασης",
        "import": "Εισαγωγή",
        "manage": "Διαχείριση",
        "new": "Δημιουργία",
        "newDecision": "Νέα απόφαση",
        "newDecisions": "Απόφαση",
        "save": "Αποθήκευση",
        "show": "Εμφάνιση",
        "start_new_group": "Έναρξη νέας ομάδας",
        "submit": "Υποβολή"
      },
      "attributes": {
        "category": "Κατηγορία",
        "created_at": "Δημιουργήθηκε στις",
        "description": "Περιγραφή",
        "name": "Τίτλος",
        "responsible": "Υπεύθυνος",
        "start_date": "Ημερομηνία έναρξης"
      },
      "labels": {
        "add_decision_partners": "Προσθήκη συνεργατών απόφασης",
        "allowCreditExplainer": "Εμφάνιση πίστωσης για προτάσεις κάτω από τον προϋπολογισμό",
        "auto_close": "Αυτόματο κλείσιμο της απόφασης μόλις λήξει η προθεσμία",
        "auto_close_info": "Το κλείσιμο μιας απόφασης εμποδίζει τον πελάτη να εγκρίνει πρόταση όταν δεν έχει ληφθεί απόφαση. Είναι χρήσιμο όταν δουλεύεις με στενές προθεσμίες.",
        "auto_share": "Αυτόματη κοινοποίηση",
        "auto_share_description": "Αυτόματη κοινοποίηση των εγκεκριμένων προτάσεων σε αυτή την ομάδα συνεργατών",
        "auto_share_subtitle": "Όταν εγκρίνεται μια νέα πρόταση",
        "auto_share_title": "Αυτόματη κοινοποίηση εγκεκριμένων προτάσεων",
        "category_name": "Όνομα κατηγορίας",
        "closes_on_deadline": "Κλείνει στην προθεσμία",
        "createNewPartner": "Ή δημιούργησε νέο συνεργάτη απόφασης",
        "decision_type_category_description": "Αν αναθέσεις μια κατηγορία όπως κουζίνα, μπάνιο κ.λπ. σε πολλές αποφάσεις, θα ομαδοποιηθούν και θα έχεις καλύτερη εποπτεία",
        "deleteCategory": "Διαγραφή κατηγορίας {category};",
        "deleteGroupSubtitle": "Αυτό σημαίνει αφαίρεση από {decision_type_name} όλων των συνομιλιών, των προτάσεων και των εγγράφων που δημιούργησε οποιοσδήποτε ανήκει σε {group_name}.",
        "deleteGroupTitle": "Πρόκειται να διαγράψεις {group_name}",
        "disclaimerDeleteGroup": "Η διαγραφή {group_name} θα καταργήσει τη δημοσίευση όλων των αποφάσεων για τους συνεργάτες απόφασης. Μπορείς να δημοσιεύσεις ξανά στους συνεργάτες απόφασης μόλις αυτή η απόφαση αποκτήσει ξανά συνεργάτες απόφασης.",
        "disclamerDeleteCategory": "Η διαγραφή {category} θα αφαιρέσει την κατηγορία από όλες τις αποφάσεις στις οποίες έχει ανατεθεί. Οι αποφάσεις δεν θα διαγραφούν.",
        "editCategory": "Επεξεργασία κατηγορίας",
        "editGroup": "Επεξεργασία {group_name}",
        "editPartnerRights": "Επεξεργασία δικαιωμάτων επικοινωνίας συνεργατών απόφασης",
        "editPartnerRightsLater": "Μπορείς πάντα να το αλλάξεις αργότερα",
        "edit_partner_group_eyebrow": "Επεξεργασία ομάδας συνεργατών",
        "existing_groups": "Υπάρχουσες ομάδες συνεργατών",
        "explainerPartners": "Πρόσθεσε εξωτερικούς συνεργάτες απόφασης και δούλεψε μαζί σε {decision_type_name}",
        "export_preparing": "Η συγκέντρωση όλων των προτάσεων μπορεί να διαρκέσει μερικά λεπτά. Θα λάβεις ειδοποίηση όταν είναι έτοιμη για λήψη.",
        "export_proposals_approved": "Έγγραφα εγκεκριμένων προτάσεων",
        "for_decision": "Για την απόφαση",
        "groupRightsWarning": "Προσοχή. Όλες οι συνομιλίες ανάμεσα στον πελάτη και τους συνεργάτες θα αφαιρεθούν. Η ενέργεια είναι μη αναστρέψιμη. Θέλεις σίγουρα να συνεχίσεις;",
        "hint": "Μπορείς να διαχειριστείς τις κατηγορίες σου στις",
        "hintSettings": "ρυθμίσεις του οργανισμού.",
        "last_updated_at": "Τελευταία ενημέρωση στις",
        "matrix": "Στατιστικά",
        "new_category": "Νέα κατηγορία απόφασης",
        "new_partner_group": "Νέα ομάδα συνεργατών",
        "noPartnersAddedYet": "Δεν έχουν προστεθεί ακόμη συνεργάτες απόφασης",
        "noResultPartner": "Κανένα αποτέλεσμα για {partner_name}",
        "partner_already_in_other_group": "Ήδη σε άλλη ομάδα",
        "partner_already_selected": "Ήδη επιλεγμένος",
        "partner_group": "Ομάδα συνεργατών",
        "partner_group_footer_empty": "Επίλεξε τουλάχιστον 1 συνεργάτη",
        "partner_group_footer_summary": "{count} συνεργάτης • {rights} | {count} συνεργάτης • {rights} | {count} συνεργάτες • {rights}",
        "partner_group_name_label": "Όνομα ομάδας συνεργατών",
        "partner_groups": "Ομάδες συνεργατών",
        "partners": "Συνεργάτες απόφασης",
        "partners_count": "Κανένας συνεργάτης | 1 συνεργάτης | {count} συνεργάτες",
        "partners_in_group": "Συνεργάτες σε αυτή την ομάδα",
        "partners_in_total": "Κανένας συνεργάτης συνολικά | 1 συνεργάτης συνολικά | {count} συνεργάτες συνολικά",
        "partners_selected_count": "Κανένας επιλεγμένος | 1 επιλεγμένος | {count} επιλεγμένοι",
        "permissions_label": "Δικαιώματα ομάδας",
        "projectUnitsTotal": "{project_name} έχει συνολικά {units_count_max} ακίνητα",
        "proposal_uploaded": "η πρόταση ανέβηκε",
        "published_state": "Κατάσταση δημοσίευσης",
        "searchPartners": "Αναζήτηση συνεργατών απόφασης",
        "selectADecision": "Επίλεξε μια απόφαση",
        "select_decision_partners": "Επίλεξε τους συνεργάτες απόφασης",
        "setUpPartners": "Ρύθμιση συνεργατών απόφασης",
        "set_rights": "Ορισμός δικαιωμάτων ομάδας για {partner_group_name}",
        "share_existing_title": "Κοινοποίηση υπαρχουσών προτάσεων",
        "share_proposals_label": "Κοινοποίηση προτάσεων",
        "start_date_description": "Ημερομηνία μόνο για εσωτερική χρήση. Μπορεί να καθορίζει τη σειρά με την οποία η ομάδα σου δουλεύει τις αποφάσεις",
        "start_date_title": "Ημερομηνία έναρξης (προαιρετικά)",
        "step0Title": "Ποιο έργο-πρότυπο και ποια απόφαση θέλεις να χρησιμοποιήσεις;",
        "step1Title": "Τι είδους απόφαση πρέπει να πάρουν οι πελάτες σου;",
        "tab_proposal_templates": "Πρότυπα προτάσεων",
        "tab_units": "Ακίνητα",
        "upsellCategoryTypes": "Αυτή η δυνατότητα δεν περιλαμβάνεται στο πακέτο σου. Επικοινώνησε μαζί μας μέσω του μπλε κουμπιού για να μάθεις περισσότερα.",
        "view": "Προβολή",
        "view_list": "Λίστα",
        "view_table": "Πίνακας",
        "writeEmployeeNameReject": "Γράψε <i><b>{employeeName}</b></i> για να συνεχίσεις."
      },
      "snackbars": {
        "duplicate": "Η απόφαση δημιουργήθηκε, αλλά η αντιγραφή από το πρότυπο μπορεί να χρειαστεί μερικά λεπτά για να ολοκληρωθεί."
      },
      "toasts": {
        "bulk_delete": "Η απόφαση διαγράφηκε με επιτυχία | Οι αποφάσεις διαγράφηκαν με επιτυχία",
        "update": "Η απόφαση ενημερώθηκε με επιτυχία"
      },
      "validation": {
        "duplicateNameAlreadyTaken": "Το «{name}» χρησιμοποιείται ήδη σε αυτό το έργο",
        "nameAlreadyTaken": "Το όνομα χρησιμοποιείται ήδη σε αυτό το έργο",
        "needName": "Ο τίτλος είναι υποχρεωτικός",
        "projectRequired": "Επίλεξε πρώτα ένα έργο",
        "selectDecisionType": "Επίλεξε τουλάχιστον 1 απόφαση",
        "selectSharingOption": "Επίλεξε σε ποιον θέλεις να κοινοποιήσεις τα έγγραφα"
      }
    }
  }
}
